import { SoundTypes } from './sound-types';

export const ErrorTypes = {
  WRONG_WAY: { name: 'ReversedDirection', soundType: SoundTypes.REVERSAL },
  FINGER_UP: { name: 'LiftedFinger', soundType: SoundTypes.FINGER_DOWN },
  OUT_OF_BOUNDS: { name: 'OutOfBounds', soundType: SoundTypes.OUT_OF_BOUNDS },
  STARTING_SPOT: { name: 'MissedStartingPoint', soundType: null },
  STARTED_WRONG_WAY: { name: 'StartedWrongWay', soundType: null }
};
